import { createContext, useContext } from "react";

export const AccountActionsContext = createContext(null);

export const useAccountActions = () => {
  const actions = useContext(AccountActionsContext);

  if (!actions) {
    throw new Error("useAccountActions must be used inside AppShell");
  }

  return actions;
};
